export default __webpack_public_path__ + "static/media/shopify.9dd94dfe.png";